import React from "react";
import styles from "./QuestionAnswer.module.less";

export default function QuestionAnswer(props: { question: string; answer: string }) {
    return (
        <div className={styles.QuestionAnswer}>
            <p>
                <span className="Heading Heading--h3 u-paddingR1">Q:</span> <span className={styles["QuestionAnswer-question"]} dangerouslySetInnerHTML={{ __html: props.question }} />
            </p>
            <p>
                <span className="Heading Heading--h3 u-paddingR1">A:</span> <span className={styles["QuestionAnswer-answer"]} dangerouslySetInnerHTML={{ __html: props.answer }} />
            </p>
        </div>
    );
}
